import { mailProActionConstants, pmaActionConstants } from "_constants";
import { mailProUtils } from "_util";
import { LOG_MODULES, LOG_CODE_PREFIX, trackException } from "common/errorTracker";

export const mailProActions = {
  approveMailProArea,
  updateAreaAsApproved
};

function approveMailProArea(listgenUserID, areaID, callbackFn = () => {}) {
  return async (dispatch) => {
    return mailProUtils
      .approveMailProAreaAPI(listgenUserID, areaID)
      .then((res) => {
        // The axios interceptor resolves errors instead of rejecting, so a
        // failed call lands here with res.data undefined — treat anything
        // that isn't an explicit true as a failed approval.
        if (!res || res.data !== true) {
          trackException({
            module: LOG_MODULES.MAILPRO,
            code: `${LOG_CODE_PREFIX.MAILPRO}APPROVE_AREA_REJECTED`,
            error: new Error(
              `Approve area API did not confirm approval (data=${String(res && res.data)})`
            ),
            httpStatus: res && res.status,
            level: 'warning',
            listgenUserID: listgenUserID,
            data: { areaID, responseData: String(res && res.data) },
          });
        }
        callbackFn(res.data);
        dispatch({
          type: mailProActionConstants.APPROVE_MAILPRO_AREA,
          payload: {
            isApproved: res.data,
          },
        });
      })
      .catch((err) => {
        console.log("Error in approveMailProArea", err);
        trackException({
          module: LOG_MODULES.MAILPRO,
          code: `${LOG_CODE_PREFIX.MAILPRO}APPROVE_AREA_FAILED`,
          error: err,
          listgenUserID: listgenUserID,
          data: { areaID },
        });
        callbackFn(false);
        dispatch({
          type: mailProActionConstants.APPROVE_MAILPRO_AREA,
          payload: {
            isApproved: false,
          },
        });
      });
  };
}

function updateAreaAsApproved(mlsAreasData, areaID) {
    return async (dispatch) => {
  let mlsAreasCopy = [...mlsAreasData];
  const index = mlsAreasCopy.findIndex((e) => e.mlsAreaID === areaID);

  if (index !== -1) {
    mlsAreasCopy[index] = { ...mlsAreasCopy[index], mailingStatus: "Approved" };
  }

  dispatch({
    type: pmaActionConstants.UPDATE_CURRENT_AREA_DATA,
    payload: mlsAreasCopy[index],
  });
  dispatch({
    type: pmaActionConstants.UPDATE_NAVBAR,
    payload: [...mlsAreasCopy],
  });
};
}
